<div [appStoryblok]="_editable()" [class.background]="!transparentBackground()" [innerHTML]="body().content"
     data-rr-shared="true"></div>
